export function isStyleBlockUsedByMacro(ixState: any, styleBlock: any) {
  const styleBlockId = styleBlock.get('_id');
  // @ts-expect-error - TS7006 - Parameter 'macro' implicitly has an 'any' type.
  const isAffected = ixState.macros.some((macro) =>
    // @ts-expect-error - TS7006 - Parameter 'trigger' implicitly has an 'any' type.
    macro.value.triggers.some((trigger) => trigger.selector === styleBlockId)
  );
  return isAffected;
}
